export const getNavItems = (t, currentRole) => [
  {
    title: 'Dashboard',
    label: t('navigation:dashboard'),
    path: '/dashboard',
    role: [
      'consumer',
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
  },
  {
    title: 'Profile',
    label: t('navigation:profile'),
    path: '/profile',
    role: ['consumer'],
  },
  {
    title: 'Pipeline',
    label:
      currentRole === 'consumer'
        ? t('navigation:myApplication', { defaultValue: 'My Applications' })
        : t('navigation:pipeline'),
    path: '/pipeline',
    role: [
      'consumer',
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
    subPaths: ['/pipeline'],
  },
  // {
  //   title: 'Quick Price',
  //   icon: <img src={documents} alt="quickPrice"></img>,
  //   path: '/quickPrice',
  //   role: ['loanOfficer', 'organization'],
  // },
  {
    title: 'Documents',
    label: t('navigation:documents'),
    path: '/documents',
    role: ['consumer'],
  },
  {
    title: 'Tools',
    label: t('navigation:tools'),
    path: '/tools',
    role: [
      'consumer',
      'organization',
      'loanOfficer',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
  },
  {
    title: 'Admin',
    label: t('navigation:admin'),
    path: '/admin',
    role: ['organization', 'superAdmin', 'branchAdmin'],
  },
  {
    title: 'Activity Log',
    label: t('navigation:activityLog'),
    path: '/activity-log',
    role: ['organization', 'superAdmin'],
    subPaths: ['/activity-log'],
  },
  {
    title: 'User Management',
    label: t('navigation:userManagement'),
    path: '/user-management',
    role: ['loanOfficer'],
    subPaths: ['/user-management'],
  },
  {
    title: 'Reports',
    label: t('navigation:reports'),
    path: '/reports',
    role: ['organization', 'loanOfficer', 'superAdmin', 'branchAdmin'],
  },
];

export const navItems = getNavItems((key) => {
  const fallback = {
    'navigation:dashboard': 'Dashboard',
    'navigation:profile': 'Profile',
    'navigation:pipeline': 'Pipeline',
    'navigation:myApplication': 'My Applications',
    'navigation:documents': 'Documents',
    'navigation:tools': 'Tools',
    'navigation:admin': 'Admin',
    'navigation:activityLog': 'Activity Log',
    'navigation:userManagement': 'User Management',
    'navigation:reports': 'Reports',
  };
  return fallback[key] || key;
});
